import React, { useContext } from 'react';
import styles from '../../css/components/common/rememberMe.css';
import CTAButton from '../buttons/CTAButton';
import { AppContext } from '../../Store';
import { play } from '../../helpers/remember-me/play';
import { logout } from '../../helpers/remember-me/logout';
import PropTypes from 'prop-types';
import { DEFAULT_ERROR_CODE } from '../../helpers/server-messages';
import { useTranslation, Trans } from 'react-i18next';
import { metrics } from '../../metrics-config';

function RememberMe({ userName }) {
	const dispatch = useContext(AppContext)[1];
	const { t } = useTranslation('translation');

	const handleRememberMePlayClick = async () => {
		try {
			const playResult = await play();

			if (playResult.errors && playResult.errors.length !== 0) {
				dispatch({ type: 'HIDE_REMEMBERME_MODAL' });
				dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(playResult.errors[0].code) });
				dispatch({ type: 'SHOW_SERVER_ERROR' });
			} else if (playResult.redirectUrl) {
				const playerId = playResult.playerId;
				if (playerId && metrics) {
					metrics.collectAccountLoginMetrics(playerId, playResult.redirectUrl);
				}
				dispatch({ type: 'HIDE_REMEMBERME_MODAL' });
				window.location.href = playResult.redirectUrl;
			}
		} catch (error) {
			dispatch({ type: 'HIDE_REMEMBERME_MODAL' });
			dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(DEFAULT_ERROR_CODE) });
			dispatch({ type: 'SHOW_SERVER_ERROR' });
		}
	};

	const handleRememberMeLogoutClick = async () => {
		try {
			const logoutResult = await logout(dispatch);

			if (logoutResult.errors && logoutResult.errors.length !== 0) {
				dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(logoutResult.errors[0].code) });
				dispatch({ type: 'SHOW_SERVER_ERROR' });
			} else {
				dispatch({ type: 'HIDE_REMEMBERME_MODAL' });
				dispatch({ type: 'ENABLE_LOGIN_INPUTS' });
			}
		} catch (e) {
			dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: t(DEFAULT_ERROR_CODE) });
			dispatch({ type: 'SHOW_SERVER_ERROR' });
		}
	};

	return (
		<div>
			<div
				className={styles.rememberMe} 
				data-testid="remember-me"
			>
				<p>
					<Trans i18nKey="translation:rememberMe.main">
						You are logged in with <span>{{ playername: userName }}</span>
					</Trans>
				</p>
				<p>
					<CTAButton
						onButtonClick={handleRememberMePlayClick}
						buttonLabel={t('rememberMe.ctaButton')}
						buttonId="pop-up_remember-me_n/a_button_login"
						extraClassName="rememberMe"
					/>
				</p>
				<p>
					{t('rememberMe.wrongUser')}
					<br/>
					<a
						onClick={handleRememberMeLogoutClick}
						className={styles.logout}
						href="#"
						id="pop-up_remember-me_n/a_text_logout"
					>
						{t('rememberMe.logOut')}
					</a>
				</p>
			</div>
		</div>
	);
}

export default RememberMe;

RememberMe.propTypes = {
	userName: PropTypes.string.isRequired
};
